import { ProfileStatus } from "./types";

export const PROFILE_STATUS_BADGE_MAP: Record<ProfileStatus, string> = {
  [ProfileStatus.UpdateRequired]: "Requires update",
  [ProfileStatus.NotStarted]: "Not Started",
  [ProfileStatus.InProgress]: "In Progress",
  [ProfileStatus.DetailsPending]: "Complete Details",
  [ProfileStatus.Completed]: "",
};
